// extracted by mini-css-extract-plugin
export var globalSlider = "slider-module--globalSlider---ICuj";
export var globalSlider__content = "slider-module--globalSlider__content--0TcCF";
export var globalSlider__footer = "slider-module--globalSlider__footer--35nfG";
export var globalSlider__header = "slider-module--globalSlider__header--eucMh";
export var globalSlider__next = "slider-module--globalSlider__next--QJvPM";
export var globalSlider__prev = "slider-module--globalSlider__prev--ylD+x";
export var globalSliderhasOverflow = "slider-module--globalSliderhasOverflow--kv6Iw";